import { render, staticRenderFns } from "./beneficiary-manager.vue?vue&type=template&id=1def1c9f&"
import script from "./beneficiary-manager.vue?vue&type=script&lang=js&"
export * from "./beneficiary-manager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports